import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

const CachedImage = ({ imagePath }) => {
    const [imageUrl, setImageUrl] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const cacheKey = `image_${imagePath}`;

        // Check localStorage cache first
        const cachedImage = localStorage.getItem(cacheKey);

        if (cachedImage) {
            setImageUrl(cachedImage);
            return;
        }

        // GitHub API fetch
        const fetchImageFromGitHub = async () => {
            try {
                // Replace these with your actual values
                const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN.trim();
                const OWNER = 'Cheedge';
                const REPO = 'lid';
                const PATH = `Resources/${imagePath}.png`;

                // Ensure environment variable is correctly loaded
                // console.log('Token Details:', {
                //     tokenLength: GITHUB_TOKEN.length,
                //     firstFiveChars: GITHUB_TOKEN.substring(0, 5),
                //     lastFiveChars: GITHUB_TOKEN.slice(-5),
                // });
                const response = await fetch(
                    `https://api.github.com/repos/${OWNER}/${REPO}/contents/${PATH}`,
                    {
                        method: 'GET',
                        // credentials: 'include', // or 'same-origin'
                        headers: {
                            Accept: 'application/vnd.github+json',
                            Authorization: `Bearer ${GITHUB_TOKEN}`,
                            'X-GitHub-Api-Version': '2022-11-28',
                        },
                    },
                );

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('Full Error Response:', {
                        status: response.status,
                        statusText: response.statusText,
                        headers: Object.fromEntries(response.headers),
                        body: errorText,
                    });

                    throw new Error(
                        `API Error: ${response.status} - ${errorText}`,
                    );
                }

                const data = await response.json();

                // Decode base64 directly to blob
                const byteCharacters = atob(data.content.replace(/\n/g, ''));
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'image/png' });

                // Create object URL
                const objectURL = URL.createObjectURL(blob);

                // Store and set image
                const cacheKey = `image_${imagePath}`;
                localStorage.setItem(cacheKey, objectURL);
                setImageUrl(objectURL);

                // // Decode base64 content
                // const imageBase64 = data.content;

                // // Store in localStorage
                // localStorage.setItem(cacheKey, imageBase64);
                // setImageUrl(imageBase64);
            } catch (err) {
                console.error('Error fetching image:', err);
                setError(err.message);
            }
        };

        fetchImageFromGitHub();
    }, [imagePath]);

    if (error) {
        return <Box>Error loading image: {error}</Box>;
    }

    if (!imageUrl) return <Box>Loading...</Box>;

    return (
        <Box mb={2} display="flex" justifyContent="center">
            <img
                src={imageUrl}
                alt="Question visual"
                style={{
                    maxWidth: '100%',
                    maxHeight: '300px',
                }}
            />
        </Box>
    );
};

export default CachedImage;
